import { createAction, props } from "@ngrx/store";
import { Establishment } from "src/app/services/api";

export const changeLanguage = createAction("[App] Change Language", props<{ language: Establishment.EnabledLanguagesEnum }>());
